import type { Group, GroupFilterState } from '../../shared/types';
import { classifyGroupTopic } from './topicClassifier';

/** Price estimate: 150đ per member */
export function getGroupPrice(group: Group): number {
  return group.member_count * 150;
}

export function filterBySearch(groups: Group[], query: string): Group[] {
  if (!query.trim()) return groups;
  const q = query.toLowerCase();
  return groups.filter(g => g.name.toLowerCase().includes(q));
}

export function filterByMemberRange(groups: Group[], min: number | null, max: number | null): Group[] {
  return groups.filter(g => {
    const minCount = min !== null ? min * 1000 : 0;
    const maxCount = max !== null ? max * 1000 : Infinity;
    return g.member_count >= minCount && g.member_count <= maxCount;
  });
}

export function filterByTopic(groups: Group[], topic: string): Group[] {
  if (!topic || topic === 'Tất cả') return groups;
  return groups.filter(g => classifyGroupTopic(g.name) === topic);
}

/**
 * Filter groups by estimated price range (in VND).
 * Price = member_count * 150
 */
export function filterByPriceRange(groups: Group[], min: number | null, max: number | null): Group[] {
  return groups.filter(g => {
    const price = getGroupPrice(g);
    if (min !== null && price < min) return false;
    if (max !== null && price > max) return false;
    return true;
  });
}

export function applyGroupFilters(groups: Group[], state: GroupFilterState): Group[] {
  let result = groups;
  result = filterBySearch(result, state.searchQuery);
  result = filterByMemberRange(result, state.minMembers, state.maxMembers);
  result = filterByTopic(result, state.topicFilter);
  return result;
}
